const initialState = {};

function reducer(state = initialState, action) {
    if (action.type === 'JIRA_STATISTICS_VALUES_SUCCESS') {
        const { components, issueTypes, labels, productCategories } = action.payload;
        return {
            ...state,
            components,
            failureTypes: issueTypes,
            labels,
            productCategories,
        };
    }

    return state;
}

export default reducer;
